import React from 'react'
import PropTypes from 'prop-types'
import {CardActionButtons as RmwcCardActionButtons} from '@rmwc/card'
import '@rmwc/card/styles'
import '@rmwc/button/styles'

const CardActionButtons = ({children, ...otherProps}) => <RmwcCardActionButtons {...otherProps}>{children}</RmwcCardActionButtons>

CardActionButtons.propTypes = {
  children: PropTypes.any
}

export {CardActionButtons}
